import React from "react";
import "../../css/style.css"; // استایل‌های خودت رو اینجا نگه دار

export default class KeyBoard extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      layoutName: "default",
    };
    
    // بایند کردن متدها
    this.handleShift = this.handleShift.bind(this);
    this.handleCapsLock = this.handleCapsLock.bind(this);
    this.handleKeyPress = this.handleKeyPress.bind(this);
  }

  // وقتی دکمه‌ای فشرده میشه
  handleKeyPress = (key) => {
    // مدیریت دکمه‌های خاص
    if (key === "{shiftleft}" || key === "{shiftright}") {
      this.handleShift();
      return;
    }
    if (key === "{capslock}") {
      this.handleCapsLock();
      return;
    }
    if (key === "{backspace}") {
      // ارسال کاراکتر حذف برای والد (اختیاری)
      if (this.props.onBackspace) this.props.onBackspace();
      return;
    }
    if (key === "{enter}") {
      // ارسال اینتر برای والد (اختیاری)
      if (this.props.onEnter) this.props.onEnter();
      return;
    }
    if (key === "{space}") {
      this.sendInput(" ");
      return;
    }
    if (key === "{tab}") {
      this.sendInput("\t");
      return;
    }

    // ارسال کاراکتر عادی
    this.sendInput(key);
  };

  sendInput = (char) => {
    if (this.props.onVirtualKeyBoardTyped) {
      this.props.onVirtualKeyBoardTyped(char);
    }
  };

  handleShift = () => {
    const { layoutName } = this.state;
    let newLayout = "default";

    if (layoutName === "default") newLayout = "shift";
    else if (layoutName === "shift") newLayout = "default";
    else if (layoutName === "capslock") newLayout = "capslockshift";
    else if (layoutName === "capslockshift") newLayout = "capslock";

    this.setState({ layoutName: newLayout });
  };

  handleCapsLock = () => {
    const { layoutName } = this.state;
    let newLayout = "default";

    if (layoutName === "default") newLayout = "capslock";
    else if (layoutName === "capslock") newLayout = "default";
    else if (layoutName === "shift") newLayout = "capslock";
    else if (layoutName === "capslockshift") newLayout = "shift";

    this.setState({ layoutName: newLayout });
  };

  render() {
    const { layout } = this.props;
    const { layoutName } = this.state;

    // تعریف لی‌اوت‌ها (همون لی‌اوت‌های قبلی)
    const layouts = {
      Phonetic: { 
        default: [
              "č δ γ ǰ š ž",
              "ā ē ī ō ū"
            ],
            shift: [
              "~ ! @ # $ % ^ & * ( ) _ + {backspace}",
              "{tab} Q W E R T Y U I O P { } |",
              '{capslock} A S D F G H J K L : " {enter}',
              "{shiftleft} Z X C V B N M < > ? {shiftright}",
              ".com @ {space}"
            ],
            capslockshift: [
                "` 1 2 3 4 &spades; 5 7 8 9 0 - = {backspace}",
                "{tab} q w e r t y u i o p [ ] \\",
                "{capslock} a s d f g h j k l ; ' {enter}",
                "{shiftleft} z x c v b n m , . / {shiftright}",
                ".com @ {space}"
            ],
            capslock: [
              "~ ! @ # $ % ^ & * ( ) _ + {backspace}",
              "{tab} Q W E R T Y U I O P { } |",
              '{capslock} A S D F G H J K L : " {enter}',
              "{shiftleft} Z X C V B N M < > ? {shiftright}",
              ".com @ {space}"
            ]
      },
      farsi: {
        default: [
                "خ ح چ ج ث ت پ ب ا آ",
                "ط ض ص ش س ژ ز ر ذ د",
                "ن م ل گ ک ق ف غ ع ظ",
                "ی ه و َ ِ ُ ً ٍ ٌ" 
              ],
              shift: [
              "× ! @ # $ % ^ & * ( ) _ + {backspace}",
              "{tab} ً ٌ ٍ ريال ، ؛ , ] [ \\ } { |",
              '{capslock} َ ُ ِ ّ ۀ آ ـ « » : " {enter}',
              "{shiftleft} ة ي ژ ؤ إ أ ء < > ؟ {shiftright}",
              ".com @ {space}"
              ],
              capslockshift: [
              "÷ 1 2 3 4 5 6 7 8 9 0 - = {backspace}",
              "{tab} ض ص ث ق ف غ ع ه خ ح ج چ پ",
              "{capslock} ش س ی ب ل ا ت ن م ک گ {enter}",
              "{shiftleft} ظ ط ز ر ذ د ئ و . / {shiftright}",
              ".com @ {space}"
              ],
              capslock: [
              "× ! @ # $ % ^ & * ( ) _ + {backspace}",
              "{tab} ً ٌ ٍ ريال ، ؛ , ] [ \\ } { |",
              '{capslock} َ ُ ِ ّ ۀ آ ـ « » : " {enter}',
              "{shiftleft} ة ي ژ ؤ إ أ ء < > ؟ {shiftright}",
              ".com @ {space}"
              ]
      },
      english: {
        default: [
                "ʾ ḇ ḏ γ ẖ ḵ p̄ š y̠ ӯ ẕ",
                "Ḇ E̠ Ḏ G̱ Ḵ P̱ Y̱ Ẕ D͟R D͟Y Y͟R",
                "s͟n t͟y yy̠ y͟t y͟d͟y y͟d͟y͟y"
              ],
              shift: [
                "~ ! @ # $ % ^ & * ( ) _ + {backspace}",
                "{tab} Q W E R T Y U I O P { } |",
                '{capslock} A S D F G H J K L : " {enter}',
                "{shiftleft} Z X C V B N M < > ? {shiftright}",
                ".com @ {space}"
              ],
              capslockshift: [
                  "` 1 2 3 4 &spades; 5 7 8 9 0 - = {backspace}",
                  "{tab} q w e r t y u i o p [ ] \\",
                  "{capslock} a s d f g h j k l ; ' {enter}",
                  "{shiftleft} z x c v b n m , . / {shiftright}",
                  ".com @ {space}"
              ],
              capslock: [
                "~ ! @ # $ % ^ & * ( ) _ + {backspace}",
                "{tab} Q W E R T Y U I O P { } |",
                '{capslock} A S D F G H J K L : " {enter}',
                "{shiftleft} Z X C V B N M < > ? {shiftright}",
                ".com @ {space}"
              ]
      },
      Pahlavi: {
        default: [
                "غ ع ب ئ ث : ا گ ی ط",
                "ج # س ش م ئئ ض صق فل چ",
                "فقث ت خ ص ق ف قف فقف آ خل",
                "قفل ظ صل ؤ ة حل حت نل نت ه",
                "مل ضل غمت ^ % أ @ $"
              ],
              shift: [
              "× ! @ # $ % ^ & * ( ) _ + {backspace}",
              "{tab} ً ٌ ٍ ريال ، ؛ , ] [ \\ } { |",
              '{capslock} َ ُ ِ ّ ۀ آ ـ « » : " {enter}',
              "{shiftleft} ة ي ژ ؤ إ أ ء < > ؟ {shiftright}",
              ".com @ {space}"
              ],
              capslockshift: [
              "÷ 1 2 3 4 5 6 7 8 9 0 - = {backspace}",
              "{tab} ض ص ث ق ف غ ع ه خ ح ج چ پ",
              "{capslock} ش س ی ب ل ا ت ن م ک گ {enter}",
              "{shiftleft} ظ ط ز ر ذ د ئ و . / {shiftright}",
              ".com @ {space}"
              ],
              capslock: [
              "× ! @ # $ % ^ & * ( ) _ + {backspace}",
              "{tab} ً ٌ ٍ ريال ، ؛ , ] [ \\ } { |",
              '{capslock} َ ُ ِ ّ ۀ آ ـ « » : " {enter}',
              "{shiftleft} ة ي ژ ؤ إ أ ء < > ؟ {shiftright}",
              ".com @ {space}"
              ]
      },
      Manavi: {
        default: [
                  "𐫀 𐫁 𐫂 𐫃 𐫄 𐫅 𐫆",
                  "𐫇 𐫈 𐫇𐫥 𐫉 𐫊 𐫋 𐫌",
                  "𐫍 𐫎 𐫏 𐫐 𐫑 𐫒 𐫓",
                  "𐫔 𐫕 𐫖 𐫗 𐫘 𐫙 𐫚",
                  "𐫛 𐫜 𐫝 𐫞 𐫟 𐫠 𐫡",
                  "𐫢 𐫣 𐫤",
                  "𐫫 𐫬 𐫭 𐫮 𐫯"
                ],
                shift: [
                "× ! @ # $ % ^ & * ( ) _ + {backspace}",
                "{tab} ً ٌ ٍ ريال ، ؛ , ] [ \\ } { |",
                '{capslock} َ ُ ِ ّ ۀ آ ـ « » : " {enter}',
                "{shiftleft} ة ي ژ ؤ إ أ ء < > ؟ {shiftright}",
                ".com @ {space}"
                ],
                capslockshift: [
                "÷ 1 2 3 4 5 6 7 8 9 0 - = {backspace}",
                "{tab} ض ص ث ق ف غ ع ه خ ح ج چ پ",
                "{capslock} ش س ی ب ل ا ت ن م ک گ {enter}",
                "{shiftleft} ظ ط ز ر ذ د ئ و . / {shiftright}",
                ".com @ {space}"
                ],
                capslock: [
                "× ! @ # $ % ^ & * ( ) _ + {backspace}",
                "{tab} ً ٌ ٍ ريال ، ؛ , ] [ \\ } { |",
                '{capslock} َ ُ ِ ّ ۀ آ ـ « » : " {enter}',
                "{shiftleft} ة ي ژ ؤ إ أ ء < > ؟ {shiftright}",
                ".com @ {space}"
                ]
      }
    };

    // انتخاب لی‌اوت فعلی
    const currentLayout = layouts[layout] || layouts['farsi']; // پیش‌فرض فارسی اگر لی‌اوت پیدا نشد
    const rows = currentLayout[layoutName] || currentLayout['default'];

    return (
      <div className='keyboard-wrapper'>
        <div className='keyboard-container'>
          {rows.map((row, rowIndex) => (
            <div key={rowIndex} className='keyboard-row'>
              {row.split(" ").map((key, keyIndex) => {
                // تشخیص دکمه‌های خاص برای استایل‌دهی متفاوت
                //const isSpecial = key.startsWith("{") && key.endsWith("}");
                const className = 'key-btn ' + this.props.layout
                ;

                return (
                  <button
                    key={keyIndex}
                    className={className}
                    onClick={() => this.handleKeyPress(key)}
                  >
                    {key === "{backspace}" ? "⌫" :
                     key === "{enter}" ? "↵" :
                     key === "{space}" ? "␣" :
                     key === "{tab}" ? "⇥" :
                     key === "{shiftleft}" || key === "{shiftright}" ? "⇧" :
                     key === "{capslock}" ? "⇪" :
                     key}
                  </button>
                );
              })}
            </div>
          ))}
        </div>
      </div>
    );
  }
}
